import React from "react";

function Home() {
    return (
        <div className="page">
            <h1>Welcome to Dental Notes</h1>
            <p>Head over to the TRANSCRIBE page to start your automated note taking journey.</p>
        </div>
    );
}

export default Home;
